import { AlphaSelectionFilter } from "../../../operations/filters/alphaSelection.js";
import { GLProgram } from "../../../program.js";
export class AlphaSelectionProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/filters/alphaSelection/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/filters/alphaSelection/fragment.glsl');
        var result = new AlphaSelectionProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['use_selection'] = gl.getUniformLocation(result._program, 'u_use_selection');
        result._uniforms['selection_mask'] = gl.getUniformLocation(result._program, 'u_selection_mask');
        result._uniforms['color'] = gl.getUniformLocation(result._program, 'u_color');
        return result;
    }

    setUniforms(parameters: AlphaSelectionFilter) {
        var self = this;
        self._gl.uniform4fv(self.uniformLocation('color'), parameters.color);
    }

}